import { useEffect, useState } from "react";
import { postMachinesList } from "../../services/FeaturedListings";
import { HomeString } from "../../utils/string";
import Card from "./card/card";
import { ApplicationId } from "../../api/url";
import CardSkeleton from "../loader/skeleton/cardSkeleton";
import NoMachineAvailable from "./noMachineAvailable";
import Search1 from "../../page/homecard";

const Listing = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [machineData, setMachineData] = useState([]);

  useEffect(() => {
    GetMachinesList();
  }, []);

  const GetMachinesList = () => {
    setIsLoading(true);
    let payload = {
      PageSize: 6,
      PageNumber: 1,
      IsLatestFirst: true,
      ApplicationId: ApplicationId,
    };
    postMachinesList(payload)
      .then((res) => {
        let showImgList = [];
        res?.data?.machines?.map?.((item, index) => {
          showImgList[index] = {
            ...item,
            image: item?.primary_image?.url,
            caption: `<div  class="bg-[#000] responsive_text_field" style="background: rgba(0,0,0,0.5); width: 90%; margin: auto; text-align:right; padding:0px 10px ">
                        ${item?.year}&nbsp;&nbsp;&nbsp;${item?.model?.number}&nbsp;&nbsp;&nbsp;${item?.model?.manufacturer?.name} -  Click for Details
                      </div>`,
            assetAdvertisementId: item?.assetAdvertisementId,
            name: item?.primary_image?.name.replaceAll(" ", "-"),
          };
        });
        setMachineData(showImgList);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  };
  return (
    <>
      <div className="custom-container pt-[18px] pb-[51px]">
        {/* <div className="text-[28px] md:text-[48px] font-bold text-center mb-[24px]  text-[#161412]">
          {HomeString.LATEST_LISTINGS}
        </div> */}
        {isLoading ? (
          <div className="grid grid-cols-3 gap-6 max-[842px]:grid-cols-1">
            {[1, 2, 3, 4, 5, 6].map(() => {
              return <CardSkeleton />;
            })}
          </div>
        ) : machineData?.length <= 0 ? (
          <div className="h-[300px] flex items-center justify-center">
            <NoMachineAvailable />
          </div>
        ) : (
          // <div className="h-[300px] flex items-center justify-center">
          //  <NoMachineAvailable />
          // </div>
          <div className="grid  gap-6  max-[842px]:grid-cols-1">
            {/* <Card />
            <Card />
            <Card />
            <Card />
            <Card />
            <Card /> */}
            <Search1 />
          </div>
        )}
      </div>
    </>
  );
};
export default Listing;
